import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import utils from '../../Shared/utils.jsx';
import { QBanner, QIcon, QBtn } from 'quasar';

export default defineComponent({
    name: 'notification',
    components: { QBanner, QIcon, QBtn },
    mixins: [BaseComponent],
    data: () => ({
        titleexpr: null,
        bodyexpr: null,
        subbodyexpr: null,
        colorexpr: null,
        dismissed: false,
    }),
    props: {
    },
    created() {
        if (this.controlData.Title)
            this.titleexpr = utils.compile(this, this.controlData.Title);

        if (this.controlData.Body)
            this.bodyexpr = utils.compile(this, this.controlData.Body);
        
        if (this.controlData.SubBody)
            this.subbodyexpr = utils.compile(this, this.controlData.SubBody);
    },
    mounted() {
    },
    computed: {
        title() {
            if(this.titleexpr)
                return this.Translate(utils.evaluate(this.titleexpr, this));
            return null;
        },
        body() {
            if (this.bodyexpr)
                return this.Translate(utils.evaluate(this.bodyexpr, this));
            return null;
        },
        subBody() {
            if (this.subbodyexpr)
                return this.Translate(utils.evaluate(this.subbodyexpr, this));
            return null;
        },
        color() {
            if (this.controlData.Color)
                return this.controlData.Color;

            return null;
        },
        dismissible() {
            if (this.controlData.Dismissible)
                return this.controlData.Dismissible;

            return null;
        },
        styles() {
            return {
                margin: '0 10px',
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
            };
        }
    },
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        onDismiss() {
            this.dismissed = true;
        },
        generateItemsFromArray(context, items, model, parentType) {
            let returnItems = [];

            if (items && Array.isArray(items)) {
                items.forEach((c, index) => {
                    if (!(typeof c === 'object'))
                        return;

                    let DynamicControl = utils.getDynamicComponent(h, c);

                    if (!DynamicControl)
                        DynamicControl = 'default-unknown';

                    if (!c.$objectId) c.$objectId = utils.generateUUID();

                    let id = c.$objectId;
                    if (index) id += '_' + index;

                    returnItems.push(
                        <DynamicControl
                            onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                            key={id}
                            type={c.ControlType}
                            name={c.ControlData.Name ? c.ControlData.Name : ''}
                            root={context.root}
                            parentType={parentType}
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}
                            sourceIndex={index}
                            sourceData={model}
                            controlName={c.Name}
                            scopeitems={context.scopeitems}
                            controlscope={context.controlscope}
                            cacheControl={c.CacheControl}
                            controlEvents={c.Events}
                        >
                        </DynamicControl>
                    );
                });
            }

            return returnItems;
        }
    },
    render() {
        if (!this.prerender_complete || !this.todisplay)
            return null;

        let type = this.color;
        // Use explicit colors so success (green) and error (red) render correctly; warning uses darker orange.
        // Info bg matches Help/Feedback (cc036609): --v-activeBackground-base instead of a primary tint mix.
        const typeConfig = {
            info: { color: 'var(--v-primary-base)', bgColor: 'var(--v-activeBackground-base, #eef0ff)', icon: 'mdi-information' },
            success: { color: 'var(--v-success-base)', icon: 'mdi-check-circle' },
            error: { color: 'var(--v-error-base)', icon: 'mdi-alert' },
            warning: { color: '#c26100', icon: 'mdi-alert' }, // darker orange (Vuetify-style)
        };
        const config = typeConfig[type] || typeConfig.info;
        const foregroundColor = config.color;
        const icon = config.icon;

        let title;
        let body;
        let notificationControls = null;

        if (this.controlData?.Controls?.length)
            notificationControls = <div class="q-ml-md row items-center">{this.generateItemsFromArray(this, this.controlData.Controls, null, 'HorizontalLayout')}</div>;

        const textStyle = { padding: 0, color: foregroundColor };
        const bgStyle = {
            backgroundColor: config.bgColor || `color-mix(in srgb, ${foregroundColor} 18%, white)`,
        };

        if (this.title && this.body) {
            title = <div style={textStyle} class="text-weight-medium">{this.title}</div>;
            body = <div style={textStyle}>{this.body}</div>;
        }
        else if (this.title)
            title = <div style={textStyle}>{this.title}</div>;
        else if (this.body)
            body = <div style={textStyle}>{this.body}</div>;

        const bannerContent = [
            title,
            body,
            this.subBody ? <div class="text-caption" style={textStyle}>{this.subBody}</div> : null,
        ].filter(Boolean);

        const vSlots = {
            avatar: () => <QIcon name={icon} size="sm" class="q-mr-md" style={{ color: foregroundColor }} />,
            default: () => bannerContent,
        };
        const showActionSlot = notificationControls || this.dismissible;
        if (showActionSlot) {
            vSlots.action = () => (
                <div class="row items-center no-wrap q-gutter-x-sm">
                    {notificationControls}
                    {this.dismissible && (
                        <QBtn
                            flat
                            round
                            dense
                            icon="mdi-close-circle"
                            style={{ color: foregroundColor }}
                            size="sm"
                            aria-label="Close"
                            onClick={this.onDismiss}
                        />
                    )}
                </div>
            );
        }

        return (
            <div
                class={{ 'c-Notification': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                style={this.styles}
                v-show={this.isvisible && !this.dismissed}
            >
                <QBanner
                    rounded
                    dense
                    class="q-mb-md"
                    style={bgStyle}
                    inlineActions={showActionSlot}
                    vSlots={vSlots}
                />
                
            </div>
        );
    }
});